<template>
  <b-row align-h="center" align-v="center" class="text-center height-all">
      <b-col md="8">
        <b-card class="text-center" :title="$t('home_login_existing_website')">
          <login-velaeasy />
        </b-card>
      </b-col>
  </b-row>
</template>

<script>

import LoginVelaeasy from '@/components/LoginVelaeasy'

export default {
  name: 'Login',
  components: {
    LoginVelaeasy
  }
}
</script>

<style lang="scss" scoped>
.height-all {
  height: 90vh;
}
</style>
